var render = function render(){var _vm=this,_c=_vm._self._c;return _c('answers',{ref:"answers",attrs:{"code_question_group":"GQ32","danger_code":"MCAL18","unique_category":true,"show_next":_vm.showNext,"show_classification":_vm.showClassification}})
}
var staticRenderFns = []

export { render, staticRenderFns }